// Module
var code = `<breadcrumbs></breadcrumbs>
<gl-header>
  <div class="info__column">
        <span class="info__field" ng-repeat="entry in \$ctrl.header">
          <span class="info__field-label">{{entry.label}}:</span>
          <span class="info__field-value">{{entry.text}}</span>
        </span>
  </div>
</gl-header>
<section class="box">
    <holiday-table
      holidays="\$ctrl.holidays"
      on-add="\$ctrl.addHoliday()"
      on-delete="\$ctrl.deleteHoliday(idx)"
      on-save="\$ctrl.saveHoliday(form, index)"
      on-cancel-add="\$ctrl.cancelAddHoliday()"
      save-disabled="\$ctrl.isSaveDisabled(form)"
    >
    </holiday-table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/holiday/holiday-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;